export enum SmartDealPaymentActionType {
  ReleaseUpfrontPayment = "ReleaseUpfrontPayment",
  RevertUpfrontPayment = "RevertUpfrontPayment",
  ReleaseFullPayment = "ReleaseFullPayment",
  RevertFullPayment = "RevertFullPayment",
}
